<template>
  <v-container>
    <v-form>
      <v-card>
        <v-container>
          <v-card-title class="title-highlight">
            {{ $t('title.admin-shipping-history-download') }}
          </v-card-title>

          <v-layout row wrap class="rowBox">
            <v-flex xs10 sm4>
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="startDate"
                    label="開始日"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="startDate"
                  @input="menu = false"
                  locale="jp-ja"
                  :day-format="startDate => new Date(startDate).getDate()"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-flex>
            
            <v-flex xs10 sm4>
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="endDate"
                    label="終了日"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="endDate"
                  @input="menu2 = false"
                  locale="jp-ja"
                  :day-format="endDate => new Date(endDate).getDate()"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
          
          <br>
          <v-flex xs12 sm6>
            <v-select
              v-model="selectCategory"
              :items="itemCategories"
              :label="$t('category')"
              :placeholder="$t('sales.select-category')"
              item-text="itemCategoryName"
              item-value="itemCategoryId"
              :sort-by="['itemCategoryId']"
              :sort-desc="[false]"
              return-object

              :menu-props="{
                attach: 'body',
                offsetY: true,
                auto: true,
                maxHeight: 360,
                contentClass: 'select-menu-overlay',
                zIndex: 3000
              }"
            ></v-select>
          </v-flex>

          <br>
          <v-select
            v-model="selectStore"
            :items="stores"
            item-text="storeName"
            item-value="storeCode"
            return-object
            :label="$t('store')"
            :placeholder="$t('sales.select-store')"
            required
            no-data-text="店舗が１つもありません"

            :menu-props="{
              attach: 'body',
              offsetY: true,
              auto: true,
              maxHeight: 360,
              contentClass: 'select-menu-overlay',
              zIndex: 3000
            }"
          ></v-select>
        </v-container>
        <br />
      </v-card>
      <br />


      <!-- 버튼 영역 -->
      <div class="footer-btns">
        <v-btn color="#4C728A" dark :to="{ name: 'admin/new-admin-menu' }" class="footer-btn">
          <v-icon color="black" left>home</v-icon>{{ $t('home-btn') }}
        </v-btn>

        <v-btn color="success" dark @click="downloadCsv()" :loading="downloadLoading" class="footer-btn">
          <v-icon dark left>get_app</v-icon>{{ $t('download-btn') }}
        </v-btn>
      </div>
    </v-form>
  </v-container>
</template>

<script>
import moment from 'moment-timezone'
import ServerApiCallService from '@/services/ServerApiCallService.js'
import axios from 'axios'
import { mapState } from 'vuex'

export default {
  created() {
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)

    if (!this.salesReportDate) {
      this.$store.commit('SET_SALES_REPORT_DATE', moment().format('YYYY/MM/DD'))
    }

    // 카테고리 정보 가져오기
    this.getItemCategories();
    // 점포정보 가져오기
    this.getAliveStores()
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
    salesReportDate: {
      get() {
        return this.$store.state.adminSession.salesReportDate
      },
      set(value) {
        this.$store.commit('SET_SALES_REPORT_DATE', value)
      },
    }
  },
  methods: {
    customFilter(items, search) {
      if (!search.supplierCode) {
        return items
      } else {
        let filteringItems = items.filter(function (item) {
          if (item.supplierCode === search.supplierCode) {
            return true
          } else {
            return false
          }
        })

        return filteringItems
      }
    },
    getItemCategories() {
      ServerApiCallService.itemCategoriesByStatus()
        .then(response => {
          this.itemCategories = response.data.itemCategories
          this.itemCategories.unshift({
            itemCategoryId: '0',
            itemCategoryName: '全て'
          })
          this.itemCategories.push({
            itemCategoryId: '9999',
            itemCategoryName: 'テスター&プレゼント商品'
          })
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    getAliveStores() {
      ServerApiCallService.getAliveStores()
        .then(response => {
          this.stores = response.data.stores
          this.stores.unshift({
            storeCode: '0',
            storeName: '全て'
          })
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    close() {
      this.updateDialog = false
    },   
    downloadCsv() {
      // 버튼 이미지가 돌아가는 그래픽
      this.downloadLoading = true;
      
      let startDate = moment(this.startDate)
      let endDate = moment(this.endDate)
      
      if (endDate.diff(startDate, 'days') > 30) {
        alert("検索期間は最大1か月(30日)です");
        this.downloadLoading = false;
        return;
      }

      if (endDate.isBefore(startDate)) {
        alert("日付を確認してください");
        this.downloadLoading = false;
        return;
      }
      
      if (Object.keys(this.selectCategory).length === 0) {
        alert("カテゴリを選択してください");
        this.downloadLoading = false;
        return;
      }
      if (Object.keys(this.selectStore).length === 0) {
        alert("店舗を選択してください");
        this.downloadLoading = false;
        return;
      }
    
      if (this.user.adminRole != '1') {
        if (this.selectCategory.itemCategoryId === "0" && this.selectStore.storeCode === "0") {
          alert("全カテゴリの全店舗検索はできません\n全店舗検索の場合はカテゴリを特定してください");
          this.downloadLoading = false;
          return;
        }
      }
     
      let request = {
        itemCategoryId: this.selectCategory.itemCategoryId,
        storeCode: this.selectStore.storeCode,
        startDate: this.startDate.replace(/-/g, ''),
        endDate: this.endDate.replace(/-/g, ''),        
      }

      axios
        .create({
          baseURL: ServerApiCallService.getServerUrl(),
          withCredentials: false, // This is the default
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json;charset=utf-8',
            accessToken: window.localStorage.getItem('accessToken'),
          },
        })
        .post('/admin/shipping-history-download', request, {
          responseType: 'blob',
        })
        .then(({ data }) => {
          let blob = new Blob([data], { type: 'text/csv' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download =
            '出荷履歴_' +
            this.startDate.replace(/-/g, '') +
            '_' +
            this.endDate.replace(/-/g, '') +
            '.csv'
          link.click()
        })
      this.downloadLoading = false
    },
  },
  data() {
    return {
      downloadLoading: false,
      updateDialog: false,
      menu: false,
      menu2: false,
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      selectCategory: {
        itemCategoryId: '0',
        itemCategoryName: '全て'
      },
      selectStore: {},
      stores: [],
      itemCategories: [],
      headers: [
        {
          text: '店舗名',
          align: 'left',
          value: 'storeName',
          width: '60%',
          sortable: false,
          fixed: true,
        },
        {
          text: '報告者',
          align: 'center',
          value: 'createdUser',
          width: '20%',
          sortable: false,
          fixed: true,
        },
        {
          text: '報告時間',
          align: 'center',
          value: 'createdAt',
          width: '20%',
          sortable: false,
          fixed: true,
        },
        {
          text: '',
          align: 'left',
          sortable: false,
          value: 'delete',
          width: '20px',
        },
      ],
      stores: [],
      salesReportConfirmHeader: [
        {
          text: '商品名',
          align: 'left',
          value: 'itemName',
          sortable: false,
          fixed: false,
        },
        {
          text: '売上個数',
          align: 'right',
          sortable: false,
          value: 'orderLimit',
          fixed: true,
        },
        {
          text: 'プレゼント',
          align: 'right',
          sortable: false,
          value: 'orderLimit',
          fixed: true,
        },
        {
          text: '売上金額',
          align: 'right',
          sortable: false,
          value: 'orderLimit',
          fixed: true,
        },
        {
          text: '参考在庫',
          align: 'right',
          sortable: false,
          value: 'orderLimit',
          fixed: true,
        },
      ],
      salesReportDetail: [],
      workedUsers: [],
      salesUsers: [],
      selectedStoreReport: [],
      remarks: '',
      sumTotal: 0,
    }
  },
}
</script>
<style>
.title-highlight {
  font-size: 20px;          /* 🔹 기본 타이틀보다 크게 */
  font-weight: bold;        /* 🔹 굵게 */
  color: #2c3e50;           /* 🔹 진한 남색 계열 */
  /*border-left: 5px solid #4C728A; /* 🔹 왼쪽에 포인트 라인 */
  padding-left: 10px;       /* 🔹 라인과 글자 사이 간격 */
  margin-bottom: 10px;      /* 🔹 아래 여백 */
}
.footer-btns {
  position: sticky;
  bottom: 0;
  background: white;
  padding: 10px 0;
  z-index: 1000;

  display: flex;
  gap: 8px;
  width: 100%;
  align-items: center;
}

.select-menu-overlay {
  z-index: 3000 !important;
}

</style>